// extracted by mini-css-extract-plugin
export default {"root":"TlErv_SIKS7VAEcJ4N38","timeControl":"tN3_Bni7q9FZ0RqAaXFr"};